import { X } from '@phosphor-icons/react'
import { motion } from 'motion/react'
import { Icon } from '../../@shadcn/components/ui/icon'

export interface GiftCardCloseButtonProps {
  onClose: () => void
}

const GiftCardCloseButton = ({ onClose }: GiftCardCloseButtonProps) => (
  <motion.button
    layout
    type='button'
    aria-label='Close'
    onClick={onClose}
    className='ui-mx-auto ui-mb-3 ui-flex ui-h-9 ui-w-9 ui-shrink-0 ui-items-center ui-justify-center ui-rounded-full ui-border ui-border-white/[0.24] ui-bg-black/25'
  >
    <Icon IconComponent={X} size='xxs' iconProps={{ color: '#ffffff', weight: 'bold' }} />
  </motion.button>
)

export default GiftCardCloseButton
